<!--
 * @Description: 
 * @Author: lz
 * @Date: 2021-06-16 09:49:32
 * @LastEditTime: 2021-06-22 16:50:23
 * @LastEditors: lz
-->
<template>
  <a-config-provider :locale="zh_CN">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>
<script>
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
moment.locale("zh-cn");
export default {
  name: "App",
  data() {
    return { zh_CN };
  }
  // mounted() {
  // oncontextmenu="return false"
  //   ondragstart="return false"
  //   onbeforecopy="return false"
  //   document.onselectstart = function (event) {
  //     event.returnValue = false;
  //   };
  //   // 或者直接返回整个事件
  //   document.onselectstart = function () {
  //     return false;
  //   };
  // },
};
</script>

<style lang="less">
#app {
  min-height: 100vh;
  background-color: #fff;
}

</style>
